import React, { useEffect, useState } from "react";
import Select from 'react-select';
import NavigateBeforeOutlinedIcon from '@mui/icons-material/NavigateBeforeOutlined';
import NavigateNextOutlinedIcon from '@mui/icons-material/NavigateNextOutlined';
// import './set-pagination.component.scss';
import { SetPaginationStyle } from './set-pagination.styles';
import { UhcSans } from "@src/apps/styles/common-style";
function SetPaginationComponent(props: any) {
    const pageSizeValues = props?.paginationConfig ? props.paginationConfig: [
        {value: 25, label: 25},
        {value: 50, label: 50},
        {value: 100, label:100},
    ];
    const [pageSize, setPageSize] = useState(props?.pageLimit?props?.pageLimit:pageSizeValues[0]);
    const [currentPageNumber, setcurrentPageNumber] = useState(props?.pageNumber?props?.pageNumber:1);
    const totallength = props.tableData.length;
    const inBetweenPagination = 'in-between';
    const [totalPages, setTotalPages] = useState(Math.ceil(props.tableData.length / pageSize.value));
    const INITIAL_PAGINATION = {
        currentPageNumber: 1,
        setIndex: 0,
        endIndex: pageSizeValues[0].value
    }
    const [endIndex, setEndIndex] = useState(INITIAL_PAGINATION.endIndex);
    const [startIndex, setStartIndex] = useState(INITIAL_PAGINATION.setIndex);
    const [pageNumber, setPageNumber]  = useState(props?.pageNumber?props?.pageNumber:'1')
    
    useEffect(()=>{
        setTotalPages(Math.ceil(props.tableData.length / pageSize.value))
        if(props?.totalRecords){
            setTotalPages(Math.ceil(props?.totalRecords / pageSize.value))
           }
        sessionStorage.setItem('updateApiOnPagination', JSON.stringify(null));
        if (!props?.page){
            pageSizeMethod(pageSize)
        }
        
    },[props.tableData])

    function pageSizeMethod(event:any) { 
        const newSize = event;
        setPageSize(newSize);
        let totalPage = Math.ceil(totallength / event.value);
        if(props?.totalRecords){
         totalPage = Math.ceil(props?.totalRecords / event.value);
        }
        setTotalPages(totalPage);
        let result;
        if ( totalPage < currentPageNumber ) {
            result = setPagination('last', newSize.value, currentPageNumber);
        } else {
            result = setPagination(inBetweenPagination, newSize.value, currentPageNumber);
        }
        props.passToTable({
            currentPageNumber: currentPageNumber,
            startIndex: result?.newStartIndex,
            endIndex: result?.newEndIndex,
            pageSize: newSize.value
        })
    }

    function setPagination(type: string = 'begin', newSize: number, pageNum) {
    let newPageNumber = currentPageNumber;
    let newStartIndex = INITIAL_PAGINATION.setIndex;
    let newEndIndex = newSize;

    if (type === 'previous') {
        newPageNumber = Math.max(1, currentPageNumber - 1);
    } else if (type === 'next') {
        newPageNumber = Math.min(totalPages, currentPageNumber + 1);
    } else if (type === 'last') {
        newPageNumber = Math.ceil(totallength / newSize);
    } else if (type === inBetweenPagination) {
        newPageNumber = Math.max(1, Math.min(totalPages, pageNum));
    } else {
        newPageNumber = INITIAL_PAGINATION.currentPageNumber;
    }

    newStartIndex = (newPageNumber - 1) * newSize;
    newEndIndex = newPageNumber * newSize;

    setcurrentPageNumber(newPageNumber);
    setStartIndex(newStartIndex);
    setEndIndex(newEndIndex);

    return { newStartIndex, newEndIndex };
}

    function PageNavigator(type: string) {
    let result;
    let newPageNumber = currentPageNumber;

    if (type === 'previous' && currentPageNumber > 1) {
        newPageNumber = currentPageNumber - 1;
        result = setPagination('previous', pageSize.value, newPageNumber);
    } else if (type === 'next' && currentPageNumber < totalPages) {
        newPageNumber = currentPageNumber + 1;
        result = setPagination('next', pageSize.value, newPageNumber);
    } else {
        return;
    }

    sessionStorage.setItem('updateApiOnPagination', JSON.stringify(true));
    props.passToTable({
        currentPageNumber: newPageNumber,
        startIndex: result?.newStartIndex,
        endIndex: result?.newEndIndex,
        pageSize: pageSize.value
    });
}

    // useEffect(() => {
    //     props.passToTable({
    //         currentPageNumber: currentPageNumber,
    //         startIndex: startIndex ,
    //         endIndex: endIndex,
    //         pageSize: pageSize.value
    //     });
    //     // enterPageNumberKeyUp()
    //   }, [currentPageNumber, startIndex, endIndex]);

    function enterPageNumberKeyUp(event:any) {
        let result, currentPageNum;
        let inputText = event.target.value;
        if (event.target.value > totalPages) {
            const inputStrArr = event.target.value.split('');
            inputText = inputStrArr[inputStrArr.length - 1];
        }

        // setPageNumber(event.target.value)
        if(inputText==='' || !inputText){
            inputText='1'
        }
        const sanitizedInput = inputText!==null?inputText.replace(/[^\d]/,''):0;
        let valueToInt: number = parseInt(sanitizedInput);
       
        if (event) {
            if (valueToInt > 0 && valueToInt <= totalPages) {
                currentPageNum = valueToInt;
                result = setPagination(inBetweenPagination, pageSize.value, valueToInt);
            } else {
                currentPageNum = totalPages;
                result = setPagination('last', pageSize.value, pageSize.value);
            }
        }  
        setcurrentPageNumber(currentPageNum);
        sessionStorage.setItem('updateApiOnPagination', JSON.stringify(true));
        props.passToTable({
            currentPageNumber: currentPageNum,
            startIndex: result?.newStartIndex,
            endIndex: result?.newEndIndex,
            pageSize: pageSize.value
        })
        
        // return result;
    }
    // Minimal fix for dropdown z-index in a modal context
    const selectStyles = { 
        menu: base => ({ ...base, zIndex: 99999, fontFamily: UhcSans}),
        menuPortal: base => ({ ...base, zIndex: 99999, fontFamily: UhcSans }),
    };

    const updatePageSize = (event:any) =>{
        sessionStorage.setItem('updateApiOnPagination', JSON.stringify(true));
        pageSizeMethod(event) 
    }

    return (
        <SetPaginationStyle padding={props?.padding}>
        <div>
            <div className="uhci-table-footer rlp-table-footer">
                <div className="rlp-left-section">
                    <div className="rlp-footer-label">Display</div>
                    <div className="selectedItem">
                    <Select 
                        value={pageSize}
                        onChange={updatePageSize}
                        options={pageSizeValues}
                        isSearchable={false}
                        styles={selectStyles}
                        menuPlacement="auto"
                        menuShouldScrollIntoView={false}
                    />
                    </div>
                    <div className="rlp-footer-label">per page</div>
                </div>


                <div className="rlp-right-section">
                    <div>
                        <form>
                            <div className="rlp-footer-label">Page</div>
                            
                                <input
                                    autoComplete="off"
                                    name="enterPage"
                                    className="page-number"
                                    value={currentPageNumber>1?currentPageNumber:pageNumber}
                                    // onKeyUp={enterPageNumberKeyUp}
                                    // onKeyUpCapture={enterPageNumberKeyUp}
                                    onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                    onChange={enterPageNumberKeyUp}
                                    style={{width:"49px"}}
                                />
                                <div className="rlp-footer-label">of {totalPages}</div>
                        </form>
                    </div>
                    <div className="pagination-btn-widget">
                        <div className="previous-button" >
                            <button style={{width:"49px"}} className={`${currentPageNumber > 1 ? 'button-style-blue': 'button-style'}`} onClick={() => PageNavigator('previous')}>
                                 <NavigateBeforeOutlinedIcon/>
                            </button>
                        </div>
                        <div className="next-button" style={{marginLeft:'8px'}} >
                            <button style={{width:"49px"}} className={`${ currentPageNumber < totalPages ? 'button-style-blue': 'button-style'}`} onClick={() => PageNavigator('next')}>
                            <NavigateNextOutlinedIcon/>
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        </SetPaginationStyle>
    )


    

}

export default SetPaginationComponent;